import fetchPhraseIfNeeded from 'helpers/utils/fetch-phrase-if-needed';
import { h, render } from 'preact';
import { StrictMode } from 'preact/compat';
import { getLists } from 'adapters/list';
import { FavouritesPayload, UPDATE_DATA, UpdateDataEvent, UpdateDataPayload } from 'helpers/pubsub';
import { addToList } from './addToList';
import { ADD_ITEMS_REQUEST, ADD_REQUEST } from 'helpers/pubsub';
import { List } from 'adapters/list/graphqlTypes';
import { updateMultiListStore } from 'helpers/store';
import AddToListModal from './AddToListModal';
import { reportError } from 'helpers/sentry';

const handleAddToListSubscription = (payload: FavouritesPayload) => {
    return Promise.all([getLists(), fetchPhraseIfNeeded()])
        .then(([res]) => {
            if (res.data.lists.length <= 1 && !payload.alwaysShowModal) {
                return addToList(payload);
            }
            render(
                <StrictMode>
                    <AddToListModal
                        lists={res.data.lists as List[]}
                        payload={payload}
                        destroy={() => {
                            render(null, document.getElementById('favs-add-to-list') as HTMLElement);
                        }}
                    />
                </StrictMode>,
                document.getElementById('favs-add-to-list') as HTMLElement
            );
        })
        .catch(e => {
            reportError(e as Error);
        });
};

const handleUpdateDataSubscription = (payload: UpdateDataPayload) => {
    if (payload.source === 'favourites') {
        updateMultiListStore(payload.data);
    }
};

export const initAddToList = () => {
    window.ikea.pubsub.subscribe(ADD_REQUEST, handleAddToListSubscription);
    window.ikea.pubsub.subscribe(ADD_ITEMS_REQUEST, handleAddToListSubscription);
    window.ikea.pubsub.subscribe<UpdateDataEvent>(UPDATE_DATA, handleUpdateDataSubscription);
};
